import {
  SheetPageBody,
  SheetPageClose,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import { Mail } from "lucide-react"
import { NewProps } from "./page-props"
import { useTranslation } from "react-i18next"
import Flash from "@/components/ui/flash"
import { useEffect } from "react"
import { useProps } from "@/lib/page-rendering"

export default function Page() {
  const { invitation } = useProps<NewProps>()
  const { t } = useTranslation(["educator_relief_listings", "common"])
  const { educator_name, relief_listing_title } = invitation

  useEffect(() => {
    window.parent.postMessage("sheet:reload_on_close")
  })

  return (
    <SheetPageBody>
      <SheetPageTitle icon={Mail}>
        {t("invitations.responses.new.title", {
          educator_name,
          relief_listing_title,
        })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <SheetPageClose>{t("common:actions.close")}</SheetPageClose>
      </div>
    </SheetPageBody>
  )
}
